<template lang="pug">
  dialog.modal.fixed.overlay.z-60.p-0.bg-gray-100-a90.text-15.md-text-17.cursor-pointer.flex.flex-col(open, @click="$emit('close')", @keydown.esc="$emit('close')")
    //- scrolling el so close button can pin to .fixed el on mobile
    .overflow-y-scroll.flex-1.flex.md-py-40.md-px-15
      //- modal body
      .overlaymenu__body.md-relative.bg-gray-100.md-bg-white.m-auto.w-full.max-w-900.py-90.px-15.md-px-30.lg-px-60.md-pt-67.md-pb-20.cursor-default(@click.stop)
        //- title
        header.text-center.mb-60
          slot(name="header")
        slot
        //- close button
        //- pins to overlay on mobile, modal body on tablet+
        .absolute.top-0.right-0.p-10.w-full.flex.justify-center.md-w-auto
          button.flex.items-center.justify-center.h-40.w-40.bg-gray-100.md-bg-transp.border.border-gray-300.rounded-full.md-border-none.focus-border-blue.focus-text-blue(@click.stop="$emit('close')", aria-label="Close")
            svg-x(style="width:1.5rem;height:1.5rem")
</template>

<script>
import svgX from '@/components/Icons/SVG-X'
let prevFocus
export default {
  name: 'Modal',
  mounted () {
    prevFocus = document.activeElement
    this.$nextTick(() => this.$el.querySelector('[tabindex]') && this.$el.querySelector('[tabindex]').focus())
  },
  destroyed () {
    if (prevFocus) prevFocus.focus()
  },
  components: { svgX }
}
</script>

<style>
</style>
